export function isDID(did){
  return (
    typeof did === 'string' &&
    did.length === 53 &&
    did.startsWith('did:jlinc:')
  )
}
